export enum Permission {
  StorefrontOnboarding = 'storefront_onboarding.modify',
}
